import type { ReactNode } from 'react';

import { cx } from './cx';

/**
 * The two-column definition list on an order: the label in a fixed 96px column, the value
 * beside it.
 *
 * A `<dl>` rather than a table, because these are one order's properties rather than rows
 * to compare — and the fixed first column is what lets the eye run down the values without
 * the labels pushing them about.
 */
export function KeyValue({ className, children }: { className?: string; children?: ReactNode }) {
  return (
    <dl className={cx('grid grid-cols-[96px_1fr] gap-x-3 gap-y-1.5 text-table m-0', className)}>
      {children}
    </dl>
  );
}

/** One pair. Rendered as `display: contents` so both halves join the parent's grid. */
export function KeyValueRow({ label, children }: { label: ReactNode; children?: ReactNode }) {
  return (
    <div className="contents">
      <dt className="text-ink-3 m-0">{label}</dt>
      <dd className="m-0 min-w-0">{children}</dd>
    </div>
  );
}
